module.exports = __webpack_public_path__ + "img/text.d46a99c2.png";